export enum PortalVariablesEnum {
  MainColor = 'mainColor',
  AccentColor = 'accentColor',
  ButtonColor = 'buttonColor',
  SectionBackgroundColor = 'sectionBackgroundColor'
}
